import React from 'react';
import styles from './TermsOfUse.module.scss';

const TestBrandTermsOfUse = () => {
  return (
    <div>
      <p>
        AthenaTelehealth is hereby absolved of any and all legal challenges to our medical care, pricing, and most
        importantly: bedside manner. Deal with it.
      </p>
      <p>
        <strong>By participating in Telehealth Services via the athenaTelehealth tool, I acknowledge that:</strong>
      </p>
      <ol>
        <li>We can do whatever we want.</li>
        <li>You have no rights.</li>
      </ol>
      <em className={styles.emphasis}>
        By joining the telehealth encounter and receiving Telehealth Services through the athenaTelehealth tool, I
        represent that I have read, understand, and agree to these athenaTelehealth Terms of Use and Informed Patient
        Consent; I have been advised of the potential risks, benefits, and alternatives of Telehealth Services; I have
        been given the opportunity to ask questions and have no remaining questions at this time; and I hereby give my
        informed consent for the use of Telehealth Services in my medical care and/or the medical care of the
        individual(s) that will be using Telehealth Services, as applicable.
      </em>
    </div>
  );
};

export default TestBrandTermsOfUse;
